import {
  Scissors,
  Star,
  Drop,
  Sun,
  Stack,
  FilmStrip,
  Ticket,
  Gear,
  Lightning,
  Target,
  ShieldCheck,
  Timer,
  Storefront,
  Briefcase,
  PaintBrush,
  Buildings,
  Package
} from "@phosphor-icons/react";

// Images from design guidelines
export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_graficos-pro-2/artifacts/t6x7kcuk_logo-finegraf.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/41bdc77a-3aa6-453e-ad98-424a2b30bfec/images/b322cc842c0c8095c61dcd9701f42ad0c4aae570f3ef50eacb410c0da66b7f12.png",
  about: "https://static.prod-images.emergentagent.com/jobs/41bdc77a-3aa6-453e-ad98-424a2b30bfec/images/28dbd2609155e413703f8bf3c1aba0ca23b7ed4815b4ae99d916b101d460f016.png",
  finalCta: "https://static.prod-images.emergentagent.com/jobs/41bdc77a-3aa6-453e-ad98-424a2b30bfec/images/d5070eed80e90d2905e5d1e00975c79c4f39d873d9ea7e15ab63e25895e0a8ab.png",
  services: "https://images.unsplash.com/photo-1773525911808-8a2cfd11cbc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwcHJpbnRpbmclMjBwcmVzcyUyMG1hY2hpbmV8ZW58MHx8fHwxNzc0NDg3MTA1fDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.pexels.com/photos/7654121/pexels-photo-7654121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

const ADDRESS_STREET = "R. das Tâmaras, 378";
const ADDRESS_DISTRICT = "Vila São Pedro";
const ADDRESS_CITY = "Americana - SP";
const ADDRESS_ZIP = "13466-460";
const ADDRESS_FULL = `${ADDRESS_STREET} - ${ADDRESS_DISTRICT}, ${ADDRESS_CITY}, ${ADDRESS_ZIP}`;

// Company contact info
export const COMPANY = {
  foundedYear: 2008,
  phone: "(19) 3601-2550",
  phoneHref: "tel:+551936012550",
  whatsapp: "(19) 99622-7811",
  email: "finegraf@hotmail.com",
  address: {
    street: ADDRESS_STREET,
    district: ADDRESS_DISTRICT,
    city: ADDRESS_CITY,
    zip: ADDRESS_ZIP,
    full: ADDRESS_FULL,
    // Embed e rota do Google Maps: ambos dispensam chave de API e conta.
    embedUrl: `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS_FULL)}&output=embed`,
    directionsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS_FULL)}`
  }
};

export const WHATSAPP_NUMBER = "5519996227811";
export const WHATSAPP_QUOTE_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento%20para%20acabamentos%20gráficos.`;
export const WHATSAPP_JOB_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Olá,%20gostaria%20de%20me%20candidatar%20a%20uma%20vaga%20na%20Finegraf.`;

// Animation variants
export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

export const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

// Gallery items
export const galleryItems = [
  {
    image: "https://images.unsplash.com/photo-1714218689420-b8ad8459c9a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwYWNrYWdpbmclMjBnb2xkJTIwZm9pbCUyMHN0YW1waW5nfGVufDB8fHx8MTc3NDQ4OTM2N3ww&ixlib=rb-4.1.0&q=85",
    title: "Hot Stamping Dourado",
    category: "Hot Stamping"
  },
  {
    image: "https://images.unsplash.com/photo-1693031630177-b897fb9d7154?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnbG9zc3klMjBsYW1pbmF0ZWQlMjBwcmludCUyMG1hdGVyaWFsc3xlbnwwfHx8fDE3NzQ0ODkzNjh8MA&ixlib=rb-4.1.0&q=85",
    title: "Laminação Industrial",
    category: "Laminação"
  },
  {
    image: "https://images.pexels.com/photos/4271624/pexels-photo-4271624.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Revistas Plastificadas",
    category: "Plastificação"
  },
  {
    image: "https://images.unsplash.com/photo-1598561222812-63429c3eee2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwYWNrYWdpbmclMjBnb2xkJTIwZm9pbCUyMHN0YW1waW5nfGVufDB8fHx8MTc3NDQ4OTM2N3ww&ixlib=rb-4.1.0&q=85",
    title: "Embalagens Premium",
    category: "Hot Stamping"
  },
  {
    image: "https://images.pexels.com/photos/3747314/pexels-photo-3747314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Materiais Impressos",
    category: "UV Localizado"
  },
  {
    image: "https://images.pexels.com/photos/7405670/pexels-photo-7405670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Foil Metalizado",
    category: "Hot Stamping"
  }
];

// Stock photos (Pexels, uso comercial livre) — trocar pelas fotos reais da
// Finegraf quando houver: basta substituir a URL do `image` correspondente.
const STOCK = {
  corteVinco: "https://images.pexels.com/photos/17260157/pexels-photo-17260157/free-photo-of-close-up-of-cardboard-boxes-and-lids.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fotolito: "https://images.pexels.com/photos/10276253/pexels-photo-10276253.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  raspadinha: "https://images.pexels.com/photos/30427909/pexels-photo-30427909.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  uvLocalizado: "https://images.pexels.com/photos/11764419/pexels-photo-11764419.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

// Services data
export const services = [
  {
    icon: Scissors,
    title: "Corte e Vinco",
    slug: "servico-corte-e-vinco",
    description: "Precisão milimétrica no corte para materiais personalizados que se destacam no mercado.",
    image: STOCK.corteVinco
  },
  {
    icon: Star,
    title: "Hot Stamping",
    slug: "servico-hot-stamping",
    description: "Acabamento premium com brilho metálico que valoriza sua marca e impressiona clientes.",
    image: galleryItems[0].image
  },
  {
    icon: Drop,
    title: "Plastificação Brilho",
    slug: "servico-plastificacao-brilho",
    description: "Proteção e sofisticação que prolongam a vida útil e realçam as cores do seu material.",
    image: galleryItems[2].image
  },
  {
    icon: Sun,
    title: "UV Localizado e Total",
    slug: "servico-uv-localizado-e-total",
    description: "Efeitos visuais impactantes que criam texturas e destaques únicos em suas peças.",
    image: STOCK.uvLocalizado
  },
  {
    icon: Stack,
    title: "Laminação Brilho e Fosca",
    slug: "servico-laminacao-brilho-e-fosca",
    description: "Elegância e durabilidade que transformam impressos comuns em materiais premium.",
    image: galleryItems[1].image
  },
  {
    icon: FilmStrip,
    title: "Fotolito",
    slug: "servico-fotolito",
    description: "Matrizes com registro exato para uma reprodução fiel da sua arte em qualquer tiragem.",
    image: STOCK.fotolito
  },
  {
    icon: Ticket,
    title: "Raspadinha",
    slug: "servico-raspadinha",
    description: "Tinta raspável aplicada com precisão para promoções, sorteios e campanhas interativas.",
    image: STOCK.raspadinha
  }
];

// Options for the quote form
export const serviceOptions = [
  { value: "corte-vinco", label: "Corte e Vinco" },
  { value: "hot-stamping", label: "Hot Stamping" },
  { value: "plastificacao", label: "Plastificação Brilho" },
  { value: "uv-localizado", label: "UV Localizado" },
  { value: "uv-total", label: "UV Total" },
  { value: "laminacao-brilho", label: "Laminação Brilho" },
  { value: "laminacao-fosca", label: "Laminação Fosca" },
  { value: "fotolito", label: "Fotolito" },
  { value: "raspadinha", label: "Raspadinha" },
  { value: "multiplos", label: "Múltiplos Acabamentos" }
];

// Differentials data
export const differentials = [
  { icon: Target, title: "Alta Precisão", description: "Acabamentos com tolerância mínima" },
  { icon: Gear, title: "Tecnologia Avançada", description: "Equipamentos de última geração" },
  { icon: Lightning, title: "Resposta Imediata", description: "Orçamentos em até 2 horas" },
  { icon: Timer, title: "Prazo Garantido", description: "Entrega no dia combinado" },
  { icon: ShieldCheck, title: "Qualidade Total", description: "Satisfação ou refazemos" }
];

// Target audience data
export const targetAudience = [
  { icon: Storefront, title: "Gráficas", description: "Parceria confiável para seus projetos" },
  { icon: Package, title: "Embalagens", description: "Acabamentos que valorizam cada caixa" },
  { icon: Briefcase, title: "Agências", description: "Acabamentos que impressionam clientes" },
  { icon: PaintBrush, title: "Designers", description: "Materialização perfeita de suas ideias" },
  { icon: Buildings, title: "Empresas", description: "Materiais que fortalecem sua marca" }
];

// Testimonials data
export const testimonials = [
  {
    name: "Carlos Eduardo",
    company: "Gráfica Express",
    text: "Trabalhamos com a Finegraf há mais de 5 anos. A qualidade dos acabamentos é impecável e nunca tivemos atrasos. Recomendo fortemente!",
    rating: 5
  },
  {
    name: "Ana Paula Mendes",
    company: "Agência Criativa Design",
    text: "Os acabamentos em hot stamping ficaram perfeitos! O atendimento é rápido e profissional. Parceiros de confiança para todos os nossos projetos.",
    rating: 5
  },
  {
    name: "Roberto Silva",
    company: "Embalagens Premium",
    text: "A laminação e o UV localizado que fizeram nas nossas embalagens elevaram completamente o nível do nosso produto. Excelente custo-benefício!",
    rating: 5
  }
];

// Navigation
export const navLinks = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/galeria", label: "Galeria" },
  { to: "/depoimentos", label: "Depoimentos" },
  { to: "/orcamento", label: "Orçamento" },
  { to: "/trabalhe-conosco", label: "Trabalhe Conosco" },
  { to: "/contato", label: "Contato" }
];
